import { render, staticRenderFns } from "./module_sku_config.vue?vue&type=template&id=026f8fc2&scoped=true"
import script from "./module_sku_config.vue?vue&type=script&lang=js"
export * from "./module_sku_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026f8fc2",
  null
  
)

export default component.exports